import { combineReducers } from 'redux';
import stageReducer from './stage/StageReducer.js';
import formReducer from './form/FormReducer.js';

export const rootReducer = combineReducers({
    stage: stageReducer,
    form: formReducer
})